export class AbstractClientPageRenderer {};
